import axios, { AxiosResponse } from 'axios';
import getApiBaseUrl from '../GetServer';

export interface Modulos {
  id: number;
  moduloName: string;
  action: string;
  actionID: number; 
}

export const getModulos = async (): Promise<Modulos[]> => {
  const baseUrl = getApiBaseUrl();
  const endpoint = `${baseUrl}dash/modules`;

  const token = localStorage.getItem('token');

  if (!token) {
    throw new Error('Token no disponible');
  }

  const response: AxiosResponse<{
    status: number;
    message: string;
    data: Modulos[];
  }> = await axios.post(endpoint, {}, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });

  if (response.data.status !== 200) {
    throw new Error(response.data.message);
  }

  return response.data.data;
};
